import { render, staticRenderFns } from "./ButtonSendCoin.vue?vue&type=template&id=0d6c1bf7&scoped=true&"
import script from "./ButtonSendCoin.vue?vue&type=script&lang=js&"
export * from "./ButtonSendCoin.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSendCoin.vue?vue&type=style&index=0&id=0d6c1bf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6c1bf7",
  null
  
)

export default component.exports